
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt/politica-privacidade",
      function () {
        return require("private-next-pages/pt/politica-privacidade.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt/politica-privacidade"])
      });
    }
  